"use strict";

exports.__esModule = true;
exports.default = void 0;

var _form = _interopRequireDefault(require("./form"));

var _formDatalist = _interopRequireDefault(require("./form-datalist"));

var _formRow = _interopRequireDefault(require("./form-row"));

var _formText = _interopRequireDefault(require("./form-text"));

var _formInvalidFeedback = _interopRequireDefault(require("./form-invalid-feedback"));

var _formValidFeedback = _interopRequireDefault(require("./form-valid-feedback"));

var _plugins = require("../../utils/plugins");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var components = {
  BForm: _form.default,
  BFormDatalist: _formDatalist.default,
  BDatalist: _formDatalist.default,
  BFormRow: _formRow.default,
  BFormText: _formText.default,
  BFormInvalidFeedback: _formInvalidFeedback.default,
  BFormFeedback: _formInvalidFeedback.default,
  BFormValidFeedback: _formValidFeedback.default
};
var _default = {
  install: (0, _plugins.installFactory)({
    components: components
  })
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/form/index.js
// module id = 382
// module chunks = 0